export default __webpack_public_path__ + "static/media/img2.f2ccfc9c.svg";